import React, { useCallback, useMemo } from 'react';
import { Box, RawButton } from '@common-fe/common-fe';

import { Option } from '@/modules/core/components/Menu/menu.types';

import { MobileItem } from '../SidebarOption.styles';

import MobileSidebarOptionDropdown from './MobileSidebarOptionDropdown';

interface MobileSidebarOptionProps {
  testId?: string;
  disabled?: boolean;
  active?: boolean;
  icon?: React.ReactNode;
  onClick: () => void;
  onPick: (url?: string) => void;
  dropdownOptions?: Option[];
}

const MobileSidebarOption: React.FC<MobileSidebarOptionProps> = ({
  testId,
  disabled,
  active,
  icon,
  onClick,
  onPick,
  dropdownOptions,
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = React.useState(false);
  const hasDropdownOptions = useMemo(() => !!dropdownOptions?.length, [dropdownOptions]);

  const handleClick = useCallback(() => {
    if (hasDropdownOptions) {
      setIsDropdownVisible(!isDropdownVisible);
      return;
    }

    onClick?.();    
  }, [isDropdownVisible, onClick, hasDropdownOptions]);

  const button = useMemo(() => (
    <RawButton data-testId={testId} disabled={disabled} onClick={handleClick}>
      <MobileItem
        width="40px"
        height="40px"
        align="center"
        justify="center"
        round="button1Round"
        disabled={disabled}
        active={active}
        >
        {icon}
      </MobileItem>
    </RawButton>
  ), [disabled, active, icon, testId, handleClick]);

  if (hasDropdownOptions) {
    return (
      <Box
        width="40px"
        height="40px"
      >
        <MobileSidebarOptionDropdown
          testId={testId}
          isDropdownVisible={isDropdownVisible}
          setIsDropdownVisible={setIsDropdownVisible}
          onPick={onPick}
          dropdownOptions={dropdownOptions}
        >
          {button}
        </MobileSidebarOptionDropdown>
      </Box>
    );
  }

  return button;
};
  

export default MobileSidebarOption;
